import HeaderBar from "../Shared/HeaderBar/HeaderBar.js";
import NavigationBar from "../Shared/NavigationBar/NavigationBar.js"

export default function BroadcastPage() {
  return (
    <>
     <HeaderBar />
        <div>
            <p>
                BroadcastPage is a placeholder page for the Broadcast feature.
            </p>
        </div>
     <NavigationBar />
    </>
  );
}